<template>
  <section class="f-section">
    <ol>
      <li v-for="item in explanationList">{{ item }}</li>
    </ol>
  </section>
</template>

<script>
export default {
  data() {
    return {
      preload_: true,
      explanationList: [
        '本页面中的测试数据，如无特别说明，均来自星纪魅族内部研发测试',
        '因平台、车型、网络、测试环境以及个人使用习惯等因素不同，实际效果可能与测试结果存在差异，请以实际为准',
        '本页面中部分产品界面和功能说明、主题风格可能因车型、配置不同而存在差异，请以实际呈现效果为准',
        '车漆多层叠加技术：按现实中真实车漆的底漆、清漆、金属粉组成原理，根据每层不同的质感和受光情况，在引擎中通过 Shader 算法分层模拟再叠加起来，从而得到比较接近真实的沉浸效果',
        '车模法线传递：通过把高模的法线朝向传递给低模，在不增加面数的情况下，让低模在摄像机里的渲染效果更平滑',
        '新生态全覆盖：Flyme Auto 提供更多深度定制应用，支持不同品牌手机应用互联上车，同时无界应用功能提供浏览器应用下载能力。Flyme Auto 还提供了无界云应用，无需占用车机内存，多方面完成生态的全覆盖。具体以车机实际体验为准。',
        'Flyme share：为保证您的行车安全，请谨慎操作多屏共享，建议在驻车情况下进行多屏共享观影',
        '浏览器 web 轻应用：可将任何网站一键添加至应用列表，再次打开无浏览器工具栏，享受应用版的体验，与各网站无官方合作，具体以车机实际体验为准',
        '无界应用：车载OS系统通用功能，非针对特定应用开发，此页面内容仅为功能演示，用户需自行下载安装第三方应用',
      ],
    }
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.f-section {
  margin-top: -5px;
  background: #eeeff2;
  color: #acacac;
  font-size: 0.28rem;
  line-height: 0.42rem;
  display: flex;
  justify-content: center;
  align-items: center;
  ol {
    margin-left: 0.25rem;
    padding: 0.92rem 0.58rem;
    li {
      list-style: decimal; // 确保显示编号
      margin-bottom: 0.1rem; // 添加间距以美化列表
    }
  }
}
</style>
